import { Action } from '@ngrx/store';
import { CrmUser, Credentials } from '@app-models/index';
export enum AuthActionTypes {
	SetAuthData = '[Auth] SetAuthData',
	Authenticated = '[Auth] Authenticated',
	NotAuthenticated = '[Auth] Not Authenticated',
	GetUserDetail = '[Auth] Get User Detail',
	GetUserDetailSuccess = '[Auth] Get User Detail Success',
	GetUserDetailFailure = '[Auth] Get User Detail Failure',
	LoginRequired = '[Auth] LoginRequired',
	LoginWithToken = '[Auth] LoginWithToken',
	Login = '[Auth] Login',
	LoginSuccess = '[Auth] Login Success',
	LoginFailure = '[Auth] Login Failure',
	LoginRedirect = '[Auth] Login Redirect',
	SelectLanguage = '[Auth] Select Language',
	Logout = '[Auth] Logout',
	RefreshToken = '[Auth] RefreshToken',
	RefreshTokenSuccess = '[Auth] RefreshToken Success',
	RefreshTokenFailure = '[Auth] RefreshToken Failure',
	Register = '[Auth] Register',
	RegisterSuccess = '[Auth] Register Success',
	RegisterFailure = '[Auth] Register Failure',
	Update = '[Auth] Update',
	UpdateSuccess = '[Auth] Update Success',
	UpdateFailure = '[Auth] Update Failure',
	ChangePassword = '[Auth] ChangePassword',
	ChangePasswordSuccess = '[Auth] ChangePassword Success',
	ChangePasswordFailure = '[Auth] ChangePassword Failure',
	ChangeEmail = '[Auth] Change Email',
	ChangeEmailSuccess = '[Auth] Change Email Success',
	ChangeEmailFailure = '[Auth] Change Email Failure',
	ChangeUserName = '[Auth] Change User Name',
	ChangeUserNameSuccess = '[Auth] Change User Name Success',
	ChangeUserNameFailure = '[Auth] Change User Name Failure',
	ForgottenPasswordVerificationSend = '[Auth] ForgottenPassword Verification Send',
	ForgottenPasswordVerificationSent = '[Auth] ForgottenPassword Verification Sent',
	ForgottenPasswordValidationSend = '[Auth] ForgottenPassword Validation Send',
	ForgottenPasswordValidated = '[Auth] ForgottenPassword Validated',
	ForgottenPasswordUpdate = '[Auth] ForgottenPassword Update',
	ForgottenPasswordUpdated = '[Auth] ForgottenPassword Updated',
	ForgottenPasswordFailure = '[Auth] ForgottenPassword Failure',
	VerifyEmail = '[Auth] Verify Email',
	VerifyEmailSuccess = '[Auth] Verify Email Success',
	VerifyEmailFailure = '[Auth] Verify Email Failure',
}
export class SetAuthData implements Action {
	readonly type = AuthActionTypes.SetAuthData;
	constructor(public payload: any) { }
}
export class Authenticated implements Action {
	readonly type = AuthActionTypes.Authenticated;
	constructor(public payload: any) { }
}
export class NotAuthenticated implements Action {
	readonly type = AuthActionTypes.NotAuthenticated;
	constructor(public payload?: any) { }
}
export class GetUserDetail implements Action {
	readonly type = AuthActionTypes.GetUserDetail;
	constructor(public payload?: any) { }
}
export class GetUserDetailSuccess implements Action {
	readonly type = AuthActionTypes.GetUserDetailSuccess;
	constructor(public payload: any) { }
}
export class GetUserDetailFailure implements Action {
	readonly type = AuthActionTypes.GetUserDetailFailure;
	constructor(public payload?: any) { }
}
export class LoginWithToken implements Action {
	readonly type = AuthActionTypes.LoginWithToken;
	constructor(public payload: boolean) { }
}
export class LoginRequired implements Action {
	readonly type = AuthActionTypes.LoginRequired;
	constructor(public payload: boolean) { }
}
export class Login implements Action {
	readonly type = AuthActionTypes.Login;
	constructor(public payload: Credentials, public rememberMe: boolean) { }
}
export class LoginSuccess implements Action {
	readonly type = AuthActionTypes.LoginSuccess;
	constructor(public payload: any, public rememberMe: boolean, public withToken: boolean) { }
}
export class LoginFailure implements Action {
	readonly type = AuthActionTypes.LoginFailure;
	constructor(public payload: any) { }
}
export class LoginRedirect implements Action {
	readonly type = AuthActionTypes.LoginRedirect;
}
export class SelectLanguage implements Action {
	readonly type = AuthActionTypes.SelectLanguage;
}
export class Logout implements Action {
	readonly type = AuthActionTypes.Logout;
}
export class RefreshToken implements Action {
	readonly type = AuthActionTypes.RefreshToken;
	constructor(public payload: any) { }
}
export class RefreshTokenSuccess implements Action {
	readonly type = AuthActionTypes.RefreshTokenSuccess;
	constructor(public payload?: any) { }
}
export class RefreshTokenFailure implements Action {
	readonly type = AuthActionTypes.RefreshTokenFailure;
	constructor(public payload: any) { }
}
export class Register implements Action {
	readonly type = AuthActionTypes.Register;
	constructor(public payload: { user: CrmUser, loginRequired: boolean }) { }
}
export class RegisterSuccess implements Action {
	readonly type = AuthActionTypes.RegisterSuccess;
	constructor(public payload: { user: CrmUser, loginRequired: boolean }) { }
}
export class RegisterFailure implements Action {
	readonly type = AuthActionTypes.RegisterFailure;
	constructor(public payload: any) { }
}
export class Update implements Action {
	readonly type = AuthActionTypes.Update;
	constructor(public payload: CrmUser, public isFreelancer: boolean) { }
}
export class UpdateSuccess implements Action {
	readonly type = AuthActionTypes.UpdateSuccess;
	constructor(public payload: CrmUser, public isFreelancer: boolean) { }
}
export class UpdateFailure implements Action {
	readonly type = AuthActionTypes.UpdateFailure;
	constructor(public payload: any) { }
}
export class ChangePassword implements Action {
	readonly type = AuthActionTypes.ChangePassword;
	constructor(public payload: { uuid: any, oldPassword: string, newPassword: string }) { }
}
export class ChangePasswordSuccess implements Action {
	readonly type = AuthActionTypes.ChangePasswordSuccess;
	constructor(public payload: any) { }
}
export class ChangePasswordFailure implements Action {
	readonly type = AuthActionTypes.ChangePasswordFailure;
	constructor(public payload: any) { }
}
export class ChangeEmail implements Action {
	readonly type = AuthActionTypes.ChangeEmail;
	constructor(public payload: CrmUser) { }
}
export class ChangeEmailSuccess implements Action {
	readonly type = AuthActionTypes.ChangeEmailSuccess;
	constructor(public payload: CrmUser) { }
}
export class ChangeEmailFailure implements Action {
	readonly type = AuthActionTypes.ChangeEmailFailure;
	constructor(public payload: any) { }
}
export class ChangeUserName implements Action {
	readonly type = AuthActionTypes.ChangeUserName;
	constructor(public payload: CrmUser) { }
}
export class ChangeUserNameSuccess implements Action {
	readonly type = AuthActionTypes.ChangeUserNameSuccess;
	constructor(public payload: CrmUser) { }
}
export class ChangeUserNameFailure implements Action {
	readonly type = AuthActionTypes.ChangeUserNameFailure;
	constructor(public payload: any) { }
}
export class ForgottenPasswordVerificationSend implements Action {
	readonly type = AuthActionTypes.ForgottenPasswordVerificationSend;
	constructor(public payload: string) { }
}
export class ForgottenPasswordVerificationSent implements Action {
	readonly type = AuthActionTypes.ForgottenPasswordVerificationSent;
}
export class ForgottenPasswordValidationSend implements Action {
	readonly type = AuthActionTypes.ForgottenPasswordValidationSend;
	constructor(public payload: { code: string, email: string }) { }
}
export class ForgottenPasswordValidated implements Action {
	readonly type = AuthActionTypes.ForgottenPasswordValidated;
}
export class ForgottenPasswordUpdate implements Action {
	readonly type = AuthActionTypes.ForgottenPasswordUpdate;
	constructor(public payload: { code: string, email: string, newPassword: string }) { }
}
export class ForgottenPasswordUpdated implements Action {
	readonly type = AuthActionTypes.ForgottenPasswordUpdated;
}
export class ForgottenPasswordFailure implements Action {
	readonly type = AuthActionTypes.ForgottenPasswordFailure;
	constructor(public payload: any) { }
}
export class VerifyEmail implements Action {
	readonly type = AuthActionTypes.VerifyEmail;
	constructor(public payload: { email: string, code: string, userId?: string, target?: string }) { }
}
export class VerifyEmailSuccess implements Action {
	readonly type = AuthActionTypes.VerifyEmailSuccess;
	constructor(public payload: { email: string }) { }
}
export class VerifyEmailFailure implements Action {
	readonly type = AuthActionTypes.VerifyEmailFailure;
	constructor(public payload: any) { }
}
export type AuthActions =
	SetAuthData
	| Authenticated
	| NotAuthenticated
	| GetUserDetail
	| GetUserDetailSuccess
	| GetUserDetailFailure
	| LoginWithToken
	| LoginRequired
	| Login
	| LoginSuccess
	| LoginFailure
	| Logout
	| SelectLanguage
	| RefreshToken
	| RefreshTokenSuccess
	| RefreshTokenFailure
	| Register
	| RegisterSuccess
	| RegisterFailure
	| Update
	| UpdateSuccess
	| UpdateFailure
	| ChangePassword
	| ChangePasswordSuccess
	| ChangePasswordFailure
	| ChangeEmail
	| ChangeEmailSuccess
	| ChangeEmailFailure
	| ChangeUserName
	| ChangeUserNameSuccess
	| ChangeUserNameFailure
	| ForgottenPasswordVerificationSend
	| ForgottenPasswordVerificationSent
	| ForgottenPasswordValidationSend
	| ForgottenPasswordValidated
	| ForgottenPasswordUpdate
	| ForgottenPasswordUpdated
	| ForgottenPasswordFailure
	| VerifyEmail
	| VerifyEmailSuccess
	| VerifyEmailFailure
